import { Image, Carousel } from 'antd'
import React, { useEffect, useState } from 'react'
import './IntroPic.css'

const IntroPic = () => {
  const [imageSize, setImageSize] = useState({height: 550, width: 800})
  const changeWidth = () => {
    if (window.innerWidth <= 1190) {
        setImageSize({width: 800, height: 800 / 1.45})
    } else if (window.innerWidth <= 800 ) {
        setImageSize({width: 650, height: 650 / 1.45})
    } else if (window.innerWidth <= 650) {
      setImageSize({width: 400, height: 400 /1.45})
    }
  }
  useEffect(() => {
    changeWidth()
  },[window.innerWidth])
return (
    <div className="carousel-container">
    <Carousel autoplay>
        <div>
            <label className="carousel-label">Wood Fencing</label>
            <Image
            height={imageSize.height}
            // width={imageSize.width}
            className="rem-pad-width miw-280 mih-400"
            src="https://s3.amazonaws.com/tangledlead.com/woodz.png"
            />
        </div>
        <div className="rem-pad-width  miw-280 mih-400">
            <label className="carousel-label">Custom Gates</label>
            <Image
            height={imageSize.height}
            // width={imageSize.width}
            className="rem-pad-width miw-280 mih-400"
            src="https://s3.amazonaws.com/tangledlead.com/images/custom-gates.jpeg"
            />
        </div>
        <div className="rem-pad-width miw-280">
            <label className="carousel-label">Fence Staining</label>
            <Image
            height={imageSize.height}
            // width={imageSize.width}
            className="rem-pad-width miw-280 mih-400"
            src="https://s3.amazonaws.com/tangledlead.com/images/wood-fencing.jpg"
            />
          </div>
          <div className="rem-pad-width miw-280 mih-400">
            <label className="carousel-label">Custom Welding</label>
            <Image
              height={imageSize.height}
              // width={imageSize.width}
              className="rem-pad-width miw-280  mih-400"
              src="https://s3.amazonaws.com/tangledlead.com/weldz.png"
            />
          </div>       
      </Carousel>
    </div>
  )
}

export default IntroPic


